(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSEditarEstatusController', SSEditarEstatusController);

    SSEditarEstatusController.$inject = ['$timeout', '$scope', '$rootScope', '$state', '$stateParams', '$uibModalInstance', 'entity', 'proyecto', 'SSMovimientoEstatusProyecto', 'SSProyecto'];

    function SSEditarEstatusController ($timeout, $scope, $rootScope, $state, $stateParams, $uibModalInstance, entity, proyecto, SSMovimientoEstatusProyecto, SSProyecto) {
        var vm = this;

        vm.sSEstatusProyecto = proyecto.estatus;
        vm.sSMovimientoEstatusProyecto = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.sSMovimientoEstatusProyecto.proyecto = {id: $stateParams.id};
            vm.sSMovimientoEstatusProyecto.fechaMovimiento = new Date();
            SSMovimientoEstatusProyecto.create(vm.sSMovimientoEstatusProyecto, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
            $state.go($state.current.name);
            $rootScope.$broadcast('updateEstatusProyectoSuccess');
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaMovimiento = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
